import * as React from 'react';

function SvgAthletics(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 14 16" {...props}>
			<path
				fill="#00182E"
				fillRule="evenodd"
				d="M13.847 3.13a.452.452 0 00.036-.085v-.023a.49.49 0 00.013-.101v-.017a.457.457 0 00-.015-.09v-.026a.532.532 0 00-.046-.1L12.149.192a.422.422 0 00-.352-.19H2.084a.42.42 0 00-.071 0h-.03a.332.332 0 00-.059.024l-.03.014H1.88c-.016.01-.03.022-.044.034l-.02.015a.392.392 0 00-.062.072L.067 2.657a.422.422 0 000 .458l4.426 7.204a3.373 3.373 0 104.916 0l4.426-7.204.012.014zM8.188 9.512l-.744-1.207 3.044-4.932v-.021h2.24l-3.977 6.45a3.222 3.222 0 00-.563-.29zm-3.794-6.17H9.51L6.949 7.5 4.394 3.342zm8.298-.844H3.874L2.856.845h8.717l1.12 1.654zM2.084 1.201l4.52 7.347.45.727H6.95c-.639 0-1.264.184-1.802.527l-4.23-6.87L2.084 1.2zM6.95 15.177a2.53 2.53 0 110-5.06 2.53 2.53 0 010 5.06z"
			/>
		</svg>
	);
}

export default SvgAthletics;
